// DS: MO0.4
import React, { useContext, useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import MonetizationPromoIcon from '@wix/da-ds/pkg/Icons/species/MonetizationPromo';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UserAvatar from '../../../../User/Avatar';
import { DeviationTypes } from '../../../../types/deviation';
import TierPromotionCard from '../../../../DeviationViews/TierPromotionCard';
import AdoptableShopCard from '../../../../ShopCard/AdoptableShopCard';
import { getDeviationEntityId } from '../../../../redux/normalizr/schemas/deviation';
import { useMeasuredCookie } from '../../../../Measured/useMeasuredCookie';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './MonetizationBlock.scss';
const DEFAULT_CARD_WIDTH = 308;
export const MonetizationBlock = ({ block: { contentType, deviations: relatedDeviations }, deviation, className })=>{
    var _measuredContainer;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const redesigned_money_banners = useFlag('redesigned_money_banners');
    const monetization_promotion_adopt = useFlag('monetization_promotion_adopt');
    const containerRef = useRef(null);
    const measuredContainer = useMeasuredCookie(undefined, containerRef, {
        cookieDim: 'width'
    });
    var _measuredContainer_width;
    const cardWidthMobile = (_measuredContainer_width = (_measuredContainer = measuredContainer) === null || _measuredContainer === void 0 ? void 0 : _measuredContainer.width) !== null && _measuredContainer_width !== void 0 ? _measuredContainer_width : DEFAULT_CARD_WIDTH;
    if (relatedDeviations && relatedDeviations.length) {
        const relatedDeviation = relatedDeviations[0];
        if (relatedDeviation.type === DeviationTypes.TIER) {
            const tierEntityId = getDeviationEntityId(relatedDeviation);
            const biData = BiData({
                evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
                typeid: relatedDeviation.typeId,
                itemid: relatedDeviation.deviationId,
                referral_info: ReferralType.SIDEBAR_PROMOTION,
                page_itemid: deviation.deviationId,
                page_typeid: getDeviationResourceType(deviation)
            });
            return /*#__PURE__*/ React.createElement("div", {
                ref: containerRef,
                className: c(s['root'], s['tier-card-root'])
            }, /*#__PURE__*/ React.createElement(BiLink, {
                href: Url.userSubscriptionsDeeplink({
                    username: relatedDeviation.author.username,
                    tierEntityId
                }),
                className: s['link'],
                biData: biData
            }), /*#__PURE__*/ React.createElement(TierPromotionCard, {
                width: isMobile ? cardWidthMobile : DEFAULT_CARD_WIDTH,
                verticalLayout: true,
                deviation: relatedDeviation
            }));
        } else if (relatedDeviation.isAdoptable) {
            return /*#__PURE__*/ React.createElement("div", {
                className: s['root']
            }, /*#__PURE__*/ React.createElement(AdoptableShopCard, {
                width: isMobile ? cardWidthMobile : DEFAULT_CARD_WIDTH,
                deviation: relatedDeviation,
                overrideHref: monetization_promotion_adopt ? Url.userShopPath(relatedDeviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.ADOPTABLES) : undefined
            }));
        }
    }
    let type;
    let link;
    let biEvid = null;
    if (contentType === 'monetization_promotion_tier' || contentType === 'monetization_promotion_tier_firstparty' || contentType === 'monetization_promotion_tier_generic' || contentType === 'monetization_promotion_tier_thirdparty' || contentType === 'subscription_promotion' /* backwards compatibility */ ) {
        type = 'tier';
        link = Url.userSubscriptionsPath({
            username: deviation.author.username
        });
        biEvid = BiEventType.VIEW_SUBSCRIPTION_TAB;
    } else if (contentType === 'monetization_promotion_adoptable' || contentType === 'monetization_promotion_adoptable_firstparty' || contentType === 'monetization_promotion_adoptable_generic') {
        type = 'adoptable';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.ADOPTABLES);
        biEvid = BiEventType.VIEW_ADOPTABLES_TAB;
    } else if (contentType === 'monetization_promotion_premium_gallery' || contentType === 'monetization_promotion_premium_gallery_generic') {
        type = 'premium_gallery';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS);
        biEvid = BiEventType.VIEW_PREMIUM_GALLERIES_TAB;
    } else if (contentType === 'monetization_promotion_commission' || contentType === 'monetization_promotion_commission_generic') {
        type = 'commission';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS);
        biEvid = BiEventType.VIEW_COMMISSIONS_TAB;
    } else if (contentType === 'monetization_promotion_pcp' || contentType === 'monetization_promotion_pcp_generic') {
        type = 'pcp';
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT);
    } else {
        return null;
    }
    if (!deviation.author) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(className, s['root'], redesigned_money_banners && s['redesigned-money-banners'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['content'], s[`type-${type}`])
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        className: s['avatar'],
        user: deviation.author,
        withTooltip: true,
        size: 40,
        relatedItemBiData: {
            typeid: deviation.typeId,
            itemid: deviation.deviationId
        }
    }), redesigned_money_banners ? /*#__PURE__*/ React.createElement("div", {
        className: s['inner']
    }, t(`sidebar.monetizationBlock.updated.var.${type}.body`), /*#__PURE__*/ React.createElement(SolidButton, {
        className: s['inner-btn'],
        variant: "main",
        size: "small",
        href: link,
        biData: biEvid ? {
            evid: biEvid,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
            referral_info: ReferralType.SIDEBAR_PROMOTION
        } : undefined
    }, /*#__PURE__*/ React.createElement(MonetizationPromoIcon, {
        promoType: type,
        size: IconSize.SMALLER,
        className: s['inner-icon'],
        disableDefaultColors: true
    }), t(`sidebar.monetizationBlock.updated.var.${type}.CTA`))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`sidebar.monetizationBlock.var.${type}.body`)), /*#__PURE__*/ React.createElement(BiLink, {
        className: s['btn-subscribe'],
        href: link,
        biData: biEvid ? {
            evid: biEvid,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
            referral_info: ReferralType.SIDEBAR_PROMOTION
        } : undefined
    }, t(`sidebar.monetizationBlock.var.${type}.CTA`)))));
};
MonetizationBlock.displayName = 'MonetizationBlock';
export default MonetizationBlock;
